module.exports = __webpack_public_path__ + "static/media/XRP-BNB.5edcb56f.svg";